export const KEYCODE = {
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  NUM_0: 48,
  NUM_9: 57,
  NUMPAD_0: 96,
  NUMPAD_9: 105,
  V: 86,
  C: 67,
  A: 65,
  X: 88,
  Y: 89,
  Z: 90,
};
